import apiService from '../apiService';

const TAX_URL = 'setup/taxes';
const taxService = {

    async createTax(payload) {
        try {
            const response = await apiService.post(`/${TAX_URL}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getAllTax(params = {}) {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await apiService.get(`/${TAX_URL}${queryParams ? `?${queryParams}` : ''}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getSingleTax(id) {
        try {
            const response = await apiService.get(`/${TAX_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async updateTax(payload, id) {
        try {
            const response = await apiService.put(`/${TAX_URL}/${id}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async deleteTax(id) {
        try {
            const response = await apiService.delete(`/${TAX_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


};

export default taxService;